import React from 'react';
import { observer } from 'mobx-react';
import { Person } from '@material-ui/icons';

import './css/BroadcastChatHeader.css';
import { RootStoreContext } from '../../../context';


class BroadcastChatHeader extends React.Component {
  static contextType = RootStoreContext;

  getSecondAnchorToTip = () => {
    const secondAnchorData = {};
    const {
      spotlights,
      anchorDetails,
      participantUsername,
      anchor,
      broadcastingTemptation,
    } = this.props;
    if (participantUsername) {
      secondAnchorData.username = participantUsername;
      secondAnchorData.nickname = anchorDetails?.nickname;
      secondAnchorData.id = anchorDetails?.id;
    }

    if (spotlights?.length) {
      if (anchor?.username === broadcastingTemptation?.username) {
        return secondAnchorData;
      }
      secondAnchorData.username = broadcastingTemptation.username;
      secondAnchorData.nickname = broadcastingTemptation.nickname;
      secondAnchorData.id = broadcastingTemptation.id;
    }

    return secondAnchorData;
  };

  onTipButtonClick = () => {
    const { anchor, isSpotlight, isSpotlighting } = this.props;
    const { tippingStore } = this.context;

    const secondAnchorToTip = this.getSecondAnchorToTip();

    tippingStore.setTippingModal({
      name: anchor.name,
      username: anchor.username,
      id: anchor.id,
    },
    secondAnchorToTip?.nickname,
    secondAnchorToTip?.username,
    secondAnchorToTip?.id,
    isSpotlight || isSpotlighting,
    );
  };

  componentWillUnmount() {
    const { tippingStore } = this.context;
    tippingStore.resetTippingAnchors();
  }

  render() {
    const {
      roomCount,
      isAnchor,
      isAuthentified,
      isBanned,
      isInGroupShow,
      showTipBtnForGroupShow,
    } = this.props;
    const canUserTip = (!isAnchor && isAuthentified) &&
      !isBanned && (!isInGroupShow || (isInGroupShow && showTipBtnForGroupShow));

    return (
      <div className="broadcast-chat-header">
        {canUserTip &&
          <button
            className="btn btn-red tipping-btn"
            onClick={this.onTipButtonClick}
          >TIP $
          </button>
        }
        <span className="user-count">
          <Person />
          <span>{roomCount}</span>
        </span>
      </div>
    );
  }
}

export default observer(BroadcastChatHeader);
